import { LocalizationProvider } from "@mui/lab";
import { BrowserRouter } from "react-router-dom";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import ConfirmDialogProvider from "context/ConfirmDialog";
import MenuPopoverProvider from "context/MenuPopover";
import PermissionsProvider from "context/PermissionsProvider";
import UserProfileProvider from "context/UserProfile";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { io } from "socket.io-client";
import "styles/app.css";
import useNotifications from "./NotificationWrapper";
import RoutesContainer from "./RoutesContainer";
import WalletBalanceProvider from "context/WalletData";
import ConfirmClientDialogProvider from "context/clientConfirmDialog";
import ConfirmCancelDialogProvider from "context/ConfirmDialogTwo";
import ConfirmDialogProvider1 from "context/ConfirmDialog-1";
import ExpiryPopup from "views/ExpiryPopUp/ExpiryPopUp";

// export let socket: any;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useNotifications();

  const url = window.location.href;
  const elem = document.querySelector("body") as HTMLElement;
  if (url.indexOf("?" + "isIframe=") != -1) {
    elem.classList.add("nestedIframe");
  } else {
    elem.classList.remove("nestedIframe");
  }

  // useEffect(() => {
  //   socket = io(process.env.REACT_APP_CRON_API || "");
  // }, []);

  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <ConfirmDialogProvider1>
            <ConfirmDialogProvider>
              <ConfirmClientDialogProvider>
                <ConfirmCancelDialogProvider>
                  <MenuPopoverProvider>
                    <PermissionsProvider>
                      <UserProfileProvider>
                        <WalletBalanceProvider>
                          <RoutesContainer />
                          <ExpiryPopup />
                        </WalletBalanceProvider>
                      </UserProfileProvider>
                    </PermissionsProvider>
                  </MenuPopoverProvider>
                </ConfirmCancelDialogProvider>
              </ConfirmClientDialogProvider>
            </ConfirmDialogProvider>
          </ConfirmDialogProvider1>
        </QueryClientProvider>
      </LocalizationProvider>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
